import { Button, Input, InputGroup, Label, Modal, Text } from '@opengov/component-library/dist';
import { IReportLocale } from '@opengov/reporting-app/application/common/locale';
import React from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';

import styles from './ShareModal.scss';

export interface IShareModalProps {
  reportLocaleText: IReportLocale;
  snapshotLink: string;
  permalinkLink: string | null;
  isSnapshotLinkCopied: boolean;
  isPermalinkLinkCopied: boolean;
  closeModal(): void;
  onSnapshotCopy(): void;
  onPermalinkCopy(): void;
}

export class ShareModal extends React.Component<IShareModalProps, any> {
  render() {
    const {
      closeModal,
      onSnapshotCopy,
      onPermalinkCopy,
      snapshotLink,
      permalinkLink,
      isSnapshotLinkCopied,
      isPermalinkLinkCopied,
      reportLocaleText
    } = this.props;
    const title = reportLocaleText.shareLink.modalTitle;
    const description = reportLocaleText.shareLink.modalDescription;
    const { modalContentWrapper, linkInputGroup, linkCopiedText, closeButton } = styles as Record<string, string>;
    return (
      <Modal.Work onClose={closeModal} title={title} description={description}>
        <div className={modalContentWrapper}>
          <div className={linkInputGroup}>
            <Label>{reportLocaleText.shareLink.snapshotLabel}</Label>
            <InputGroup width="full">
              <Input.Text.Default value={snapshotLink} dataTest="share-link-snapshot-display" />
              <InputGroup.Suffix>
                <CopyToClipboard text={snapshotLink}>
                  <Button.Neutral onClick={onSnapshotCopy} dataTest="share-link-snapshot-copy-button">
                    {reportLocaleText.shareLink.copyLinkButton}
                  </Button.Neutral>
                </CopyToClipboard>
              </InputGroup.Suffix>
            </InputGroup>
            <div className={linkCopiedText}>
              {isSnapshotLinkCopied && (
                <Text size="small" font="condensed" color="light">
                  {reportLocaleText.shareLink.snapshotCopySuccessMessage}
                </Text>
              )}
            </div>
          </div>
          {permalinkLink && (
            <div className={linkInputGroup}>
              <Label>{reportLocaleText.shareLink.permalinkLabel}</Label>
              <InputGroup width="full">
                <Input.Text.Default value={permalinkLink} dataTest="share-link-permalink-display" />
                <InputGroup.Suffix>
                  <CopyToClipboard text={permalinkLink}>
                    <Button.Neutral onClick={onPermalinkCopy} dataTest="share-link-permalink-copy-button">
                      {reportLocaleText.shareLink.copyLinkButton}
                    </Button.Neutral>
                  </CopyToClipboard>
                </InputGroup.Suffix>
              </InputGroup>
              <div className={linkCopiedText}>
                {isPermalinkLinkCopied && (
                  <Text size="small" font="condensed" color="light">
                    {reportLocaleText.shareLink.permalinkCopySuccessMessage}
                  </Text>
                )}
              </div>
            </div>
          )}
          <div className={closeButton}>
            <Button.Neutral.Default onClick={closeModal} dataTest="share-link-close-modal-button">
              {reportLocaleText.shareLink.closeModalButton}
            </Button.Neutral.Default>
          </div>
        </div>
      </Modal.Work>
    );
  }
}
